import { render, staticRenderFns } from "./InformationCost.vue?vue&type=template&id=95bf4810&scoped=true"
import script from "./InformationCost.vue?vue&type=script&lang=ts"
export * from "./InformationCost.vue?vue&type=script&lang=ts"
import style0 from "./InformationCost.vue?vue&type=style&index=0&id=95bf4810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bf4810",
  null
  
)

export default component.exports